export default `<h1><span style="font-family: Anuphan">เคสมือถือที่ตอบโจทย์ทั้งการใช้งานและไลฟ์สไตล์</span></h1>`
